import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAccommodationOfferShort } from '../../interfaces/interface';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { featureIcons } from 'src/app/core/utilits';

@Component({
  selector: 'app-offer-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatDividerModule,
    MatGridListModule,
  ],
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss'],
})
export class OfferCardComponent {
  public listFeatureIcons = featureIcons;
  offerItem = input.required<IAccommodationOfferShort>();
  goToOffer = output<number>();

  hasFeature(features: string[], keyword: string): boolean {
    if (!features || !Array.isArray(features)) return false;
    return features.some(f => f.toLowerCase().includes(keyword.toLowerCase()));
  }

  displayFeatures(features: string[]): string[] {
    if (!features) return [];
    const hiddenKeywords = ['bed', 'bedroom', 'bath'];
    return features.filter(
      f => !hiddenKeywords.some(k => f.toLowerCase().includes(k.toLowerCase()))
    );
  }

  getFirstPhoto(offer: any): string {
    if (!offer) return '';

    try {
      const photos =
        typeof offer.photos === 'string'
          ? JSON.parse(offer.photos)
          : offer.photos;
      return Array.isArray(photos) && photos.length > 0
        ? photos[0]
        : '../../assets/no-img.png';
    } catch (e) {
      console.warn('Photo parse error', e);
      return '../../assets/no-img.png';
    }
  }
}
